(() => {
  const feedback = document.getElementById('DivinoCartFeedback');
  if (!feedback || feedback.dataset.initialized === 'true') return;

  feedback.dataset.initialized = 'true';
  let dismissTimeout;

  document.addEventListener('cart:update', (event) => {
    const detail = event.detail?.data;
    const fromProductForm =
      detail?.source === 'product-form-component' || event.target?.closest?.('product-form-component');

    if (!fromProductForm || detail?.didError) return;

    window.clearTimeout(dismissTimeout);
    feedback.classList.remove('is-visible');

    window.requestAnimationFrame(() => {
      feedback.classList.add('is-visible');
      dismissTimeout = window.setTimeout(() => feedback.classList.remove('is-visible'), 2600);
    });
  });
})();
